export enum PageNavigationDirection {
  NEXT = 'next',
  PREVIOUS = 'previous',
}
